import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import IconComponent from "@CubeComponents/icons";
import ImageEditorModal from "@Components/UserProfileComponents/ImageEditorModal";
import { useSelector } from "react-redux";
import { getImageUrl } from "@Utils";
import { Box } from "@mui/material";
import { RootState } from "@Reducers/index";

function ImageEditor({
  imageData = "",
  defaultImageData,
  isEditable = true,
  onDelete,
  onSubmitFunction,
  heading,
}: any) {
  const { t } = useTranslation();
  const layout = useSelector((state: RootState) => state.layout);

  const [imgSrc, setImgSrc] = useState(imageData);
  const [tempImgSrc, setTempImgSrc] = useState(imageData);
  const [showOverlay, setShowOverlay] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  useEffect(() => {
    setImgSrc(imageData || defaultImageData || (getImageUrl() ?? "") + (layout.PROJECT_LOGO ?? ""));
    setTempImgSrc(imageData);
  }, [imageData, layout, defaultImageData]);

  const handleModalOpen = () => {
    setOpenEditModal(!openEditModal);
  };

  const handleImgSaveClick = (base64EncodedImg: any) => {
    onSubmitFunction(base64EncodedImg);
    setImgSrc(base64EncodedImg);
  };

  const handleEditClick = () => {
    handleModalOpen();
  };

  const handleHover = () => {
    setShowOverlay(true);
  };

  const handleBlur = () => {
    setShowOverlay(false);
  };

  return (
    <>
      <Box className="relative flex w-full" onMouseEnter={handleHover} onMouseLeave={handleBlur}>
        {isEditable && showOverlay && (
          <div className="absolute flex flex-row h-full w-full items-center cursor-pointer">
            <Box className="h-full w-full relative" onClick={handleEditClick}>
              <div className="flex h-full w-full bg-white opacity-40 hover:opacity-80">
                <IconComponent
                  name="editProfile"
                  width="1.25rem"
                  height="1.25rem"
                  parentContainerClass="h-5 opacity-1 absolute inset-0 m-auto"
                />
              </div>
            </Box>

            {tempImgSrc && (
              <Box className="h-full w-full relative" onClick={onDelete}>
                <div className="flex h-full w-full bg-white opacity-40 hover:opacity-80">
                  <IconComponent
                    name="delete"
                    width="1.25rem"
                    height="1.25rem"
                    parentContainerClass="h-5 opacity-1 absolute inset-0 m-auto"
                  />
                </div>
              </Box>
            )}
          </div>
        )}
        <img src={imgSrc} alt="logo" width="100%" />
      </Box>
      {openEditModal && (
        <ImageEditorModal
          closeModal={handleModalOpen}
          onSubmitFunction={handleImgSaveClick}
          heading={heading || t("Add Project Image")}
          existingImg={imageData}
        />
      )}
    </>
  );
}

export default ImageEditor;
